module.exports = __webpack_public_path__ + "img/enjoying_watching.0529332b.svg";